/**
 * AMAÇ: Kimlik doğrulama API çağrıları — kayıt, giriş/çıkış, e-posta doğrulama,
 * şifre sıfırlama ve profil/avatar güncelleme
 */
import apiClient from './apiClient';
import logger from '../utils/logger';

export const register = async (payload) => {
  /* payload: { email, username, name, last_name, password, avatar } */
  const { data } = await apiClient.post('/api/auth/register', payload);
  logger.info('Kullanıcı kaydedildi', { email: payload.email });
  return data;
};

export const login = async (email, password) => {
  const { data } = await apiClient.post('/api/auth/login', { email, password });
  localStorage.setItem('streak_token', data.token);
  logger.action('Kullanıcı giriş yaptı', { email });
  return data;
};

export const googleLogin = async (idToken) => {
  const { data } = await apiClient.post('/api/auth/google', { id_token: idToken });
  localStorage.setItem('streak_token', data.token);
  logger.action('Google ile giriş yapıldı');
  return data;
};

export const logout = () => {
  localStorage.removeItem('streak_token');
  logger.action('Kullanıcı çıkış yaptı');
};

export const getMe = async () => {
  const { data } = await apiClient.get('/api/auth/me');
  return data;   // { user }
};

export const updateProfile = async (payload) => {
  /* payload: { name?, last_name?, username?, avatar? } */
  const { data } = await apiClient.patch('/api/auth/profile', payload);
  logger.action('Profil güncellendi');
  return data.user;
};

export const verifyEmail = async (email, code) => {
  const { data } = await apiClient.post('/api/auth/verify-email', { email, code });
  return data;
};

export const resendVerification = async (email) => {
  const { data } = await apiClient.post('/api/auth/resend-verification', { email });
  return data;
};

export const forgotPassword = async (email) => {
  const { data } = await apiClient.post('/api/auth/forgot-password', { email });
  return data;
};

export const resetPassword = async (token, password) => {
  const { data } = await apiClient.post('/api/auth/reset-password', { token, password });
  return data;
};

export const uploadAvatar = async (file) => {
  const form = new FormData();
  form.append('avatar', file);
  const { data } = await apiClient.post('/api/auth/avatar', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data.user;
};

/* Hesabı ve tüm verileri kalıcı olarak siler (şifre doğrulamalı — KVKK silme hakkı) */
export const deleteAccount = async (password) => {
  const { data } = await apiClient.delete('/api/auth/account', { data: { password } });
  return data;
};

/* Mevcut kullanıcının KVKK onayını damgalar (ConsentGate penceresi kullanır) */
export const acceptConsent = async () => {
  const { data } = await apiClient.post('/api/auth/consent');
  return data;
};
